<ion-app>
  <app-nav [menuOptions]="this.appPages"></app-nav>
  <ion-split-pane [when]="false" contentId="main-content">
    <ion-menu contentId="main-content" menuId="main-menu" type="overlay">
      <ion-content [forceOverscroll]="false">
        <ion-list id="nav-list">
          <ion-menu-toggle [hidden]="p.hidden" autoHide="false" *ngFor="let p of appPages; let i = index">
            <a routerDirection="root" [routerLink]="p.path" routerLinkActive="selected"
              [routerLinkActiveOptions]="this.routerMatchOpts">
              <ion-item fill="solid" lines="none" detail="false">
                <ion-icon slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'"></ion-icon>
                <ion-label>{{ p.label | translate }}</ion-label>
              </ion-item>
            </a>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
      <app-footer></app-footer>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
